import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { unitPrice } from '../../../../../../../utils/product'
import { FormattedMessage } from 'react-intl'

export default props => {
    useStyles(classes)
    const { order } = props
    const [itemTotal, shippingPrice, shippingInsurancePrice, orderTotal] = [order?.paymentItemTotal, order?.shippingPrice, order?.shippingInsurancePrice, order?.orderTotal]


    return <div className={classes.Container}>
        <div className={classes.Hd}><FormattedMessage id="order_summary" defaultMessage="Order Summary"/></div>
        <div className={classes.Bd}>
            <div className={classes.Lines}>
                <div className={classes.Line}>
                    <span className={classes.Label}> <FormattedMessage id="order_number" defaultMessage="Order No."/></span>
                    <span className={classes.Value}>{order?.id}</span>
                </div>
                <div className={classes.Line}>
                    <span className={classes.Label}><FormattedMessage id="item_total" defaultMessage="Item Total"/></span>
                    <span className={classes.Value}>{unitPrice(itemTotal)}</span>
                </div>
                <div className={classes.Line}>
                    <span className={classes.Label}><FormattedMessage id="shipping_price" defaultMessage="Shipping Price"/></span>
                    <span className={classes.Value}>{unitPrice(shippingPrice)}</span>
                </div>

                {
                    shippingInsurancePrice && shippingInsurancePrice?.amount > 0 && <div className={classes.Line}>
                        <span className={classes.Label}><FormattedMessage id="shipping_insurance" defaultMessage="Shipping Insurance"/></span>
                        <span className={classes.Value}>{unitPrice(shippingInsurancePrice)}</span>
                    </div>
                }

            </div>
        </div>
        <div className={classes.Fd}>
            <div className={classes.Line}>
                <span className={classes.Label}><FormattedMessage id="order_total" defaultMessage="Order Total"/></span>
                <span className={classes.Value}>{unitPrice(orderTotal)}</span>
            </div>
        </div>
    </div>
}